// src/hooks/useAnalytics.ts
// Helper to push events to GTM's dataLayer safely

export const useAnalytics = () => {

  const trackEvent = (
    eventName: string,
    params?: Record<string, string | number | boolean>
  ) => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
  };

  const trackPageView = (pagePath: string, pageTitle?: string) => {
    trackEvent('page_view', {
      page_path:  pagePath,
      page_title: pageTitle || document.title,
    });
  };

  return { trackEvent, trackPageView };
};